/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, Provider, useContextProps } from 'react-aria-components';
import { SearchField, SearchFieldContext, type SearchFieldProps } from '../search-field/search-field.component';
import { TextButton, TextButtonContext } from '../text-button/text-button.component';

interface SearchBarProps extends SearchFieldProps {
  /** Callback when the cancel button is pressed. If not provided, the cancel button will not be rendered. */
  onCancel?: () => void;
  style?: stylex.StyleXStyles;
}

const SearchBarContext = createContext<ContextValue<SearchBarProps, HTMLDivElement>>({});

const SearchBar = forwardRef((props: SearchBarProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, SearchBarContext);

  const { style, onCancel, ...searchFieldProps } = props;

  return (
    <div ref={ref} {...stylex.props(styles.base, style)}>
      <Provider values={[
        [SearchFieldContext, {
          size: 44,
          isRounded: true,
          style: styles.searchField,
        }],
        [TextButtonContext, {
          variant: 'primary',
          size: 32,
        }],
      ]}>
        <SearchField {...searchFieldProps} />
        {onCancel && <TextButton onPress={onCancel}>Cancel</TextButton>}
      </Provider>
    </div>
  );
});

const styles = stylex.create({
  base: {
    gap: 16,
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },
  searchField: {
    flex: '1',
    minWidth: 0,
  },
});

export { SearchBar, SearchBarContext, type SearchBarProps };
